var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['sprite-' + _vm.timePartOfDay, 'sprite-' + _vm.statussCode]})])}
var staticRenderFns = []

export { render, staticRenderFns }